<div class="about-us">
  <app-hero-section [header]="header" [imagePath]="imagePath" [description]="description" [joinChat]="joinChat">
  </app-hero-section>

  <app-image-with-text [imageUrl]="imageUrl" [imageText]="imageText" [buttonText]="buttonText"
    [routerButton]="routerButton" [isProductsPage]="isProductsPage">
  </app-image-with-text>


  <div class="about-us__content">
    <div class="about-us__container">
      <div class="about-us__vision-value">
        <h2 l10nTranslate>Our Vision</h2>
        <p l10nTranslate>Transform the governance, risk, and compliance technology landscape, to enable organizations modernize their practices and reduce operational overhead
        </p>
      </div>
      <div class="about-us__mission-value">
        <h2 l10nTranslate>Our Mission</h2>
        <ul>
          <li l10nTranslate>Reduce Human-Driven Cybersecurity Risks</li>
          <li l10nTranslate>Simplify Compliance and Risk Management</li>
          <li l10nTranslate>Facilitate Seamless Business Continuity</li>
        </ul>
      </div>
      <div class="about-us__vision-value">
        <h2 l10nTranslate>Our Values</h2>
        <div class="about-us__value-holder">
          <div class="about-us__value-item">
            <mat-icon svgIcon="thumb"></mat-icon>
            <div l10nTranslate>Be Passionate</div>
          </div>
          <div class="about-us__value-item">
            <mat-icon svgIcon="thumb"></mat-icon>
            <div l10nTranslate>Be Creative</div>
          </div>
          <div class="about-us__value-item">
            <mat-icon svgIcon="chart"></mat-icon>
            <div l10nTranslate>Honor Partnership</div>
          </div>
          <div class="about-us__value-item">
            <mat-icon svgIcon="chart"></mat-icon>
            <div l10nTranslate>Demonstrate Commitment</div>
          </div>
          <div class="about-us__value-item">
            <mat-icon svgIcon="tree"></mat-icon>
            <div l10nTranslate>Instill Trust</div>
          </div>
          <div class="about-us__value-item">
            <mat-icon svgIcon="tree"></mat-icon>
            <div l10nTranslate>Celebrate Client’s Success</div>
          </div>
        </div>


      </div>
    </div>
            </div>
            </div>



  <div class="about-us__services">
    <div class="">
      <h2 l10nTranslate>Holistic Cybersecurity Solutions</h2>
      <p l10nTranslate>We are focused on providing solutions that make the difference for your GRC program Automate operations get advisory services and utilize our GRC assessment services</p>
    <div class="about-us__container">
      

      <div class="about-us__services-row">
        <div class="about-us__services-item-holder">
          <div class="about-us__services-item" l10nTranslate>
            Automation
          </div>
        </div>
        <div class="about-us__services-line"></div>
        <div class="about-us__services-item-holder">
          <div class="about-us__services-item" l10nTranslate>
            Advisory
          </div>
        </div>
        
        <div class="about-us__services-line"></div>
        <div class="about-us__services-item-holder">
          <div class="about-us__services-item" l10nTranslate>
            Content
          </div>
        </div>
        <div class="about-us__services-line"></div>
        <div class="about-us__services-item-holder">
          <div class="about-us__services-item" l10nTranslate>
            Assessment
          </div>
        </div>
      </div>
      <div class="about-us__services-btn-holder">
        <button class="about-us__services-btn" [routerLink]="['/contact-us']" l10nTranslate>Contact us</button>
      </div>
    </div>
  </div>
  <div class="about-us__certified">
    <div class="about-us__certified-container">
      <div class="about-us__certified-holder">
        <div class="about-us__certified-vector-holder">
          <div class="about-us__certified-vector"></div>
          <img src="../../../../assets/images/Isolation_Mode.png" alt="Isolation">
        </div>
        <div class="about-us__certified-row">
          <div class="about-us__certified-item">
          <div class="about-us__certified-text" [innerHTML]="'We Are Certified'" l10nTranslate></div>
        </div>
        <div class="about-us__certified-item about-us__certified-logos">
          <img class="ISO-logo" src="../../../../assets/images/ISO.svg" alt="ISO">
        </div>
        </div>
        
      </div>
    </div>
  </div>
</div>